import React from "react";
import MainLayout from "../../layouts/MainLayout";
import { GuadalarajaModal } from "../../components/working-at-forager-current-oppotunities/guadalaraja";
import AppModal from "../../components/common/AppModal";
import CardModal from "../../components/CardModal";
import rocket from "../../assets/img/about/rockets.png";
import wave from "../../assets/img/home/wave.svg";

export default function News() {
  const show = false;

  const cards = [
    {
      image: require("../../assets/img/working/orange.png"),
      title: "Lorem ipsum dolor 1",
      subtitle: "sbutitle",
      className: "col-span-4 lg:col-span-1",
      modalContent: <GuadalarajaModal />,
    },
    {
      image: require("../../assets/img/working/building.png"),
      title: "Lorem ipsum dolor 2",
      subtitle: "sbutitle",
      className: "col-span-2 lg:col-span-1",
      modalContent: <GuadalarajaModal />,
    },
    {
      image: require("../../assets/img/working/table.png"),
      title: "Lorem ipsum dolor 3",
      subtitle: "sbutitle",
      className: "col-span-2 lg:col-span-2",
      modalContent: <GuadalarajaModal />,
    },
    {
      image: require("../../assets/img/working/orange.png"),
      title: "Lorem ipsum dolor 1",
      subtitle: "sbutitle",
      className: "col-span-4 lg:col-span-2",
      modalContent: <GuadalarajaModal />,
    },
    {
      image: require("../../assets/img/working/building.png"),
      title: "Lorem ipsum dolor 2",
      subtitle: "sbutitle",
      className: "col-span-2 lg:col-span-1",
      modalContent: <GuadalarajaModal />,
    },
    {
      image: require("../../assets/img/working/table.png"),
      title: "Lorem ipsum dolor 3",
      subtitle: "sbutitle",
      className: "col-span-2 lg:col-span-1",
      modalContent: <GuadalarajaModal />,
    },
  ];
  return (
    <MainLayout>
      <section className="bg-dark-denim">
        <section className="bg-dark-denim md:pb-14">
          <div className="app-forager-international-news with-curved-bottom bg-no-repeat bg-cover px-0 pt-5">
            <div className="h-48 md:h-44 lg:mt-14 grid place-items-center">
              <h1 className="text-white text-4xl lg:text-6xl w-10/12 text-center">
                exciting forager news
              </h1>
            </div>
          </div>
          <div className="container mx-auto grid grid-cols-1 lg:grid-cols-7 justify-center items-center gap-x-8 mt-14 relative">
            <img
              src={rocket}
              alt=""
              className="hidden lg:block absolute -top-24 left-24 w-1/3 -rotate-6 xl:-rotate-3 2xl:-rotate-2 mt-4"
            />
          </div>
          <div className="px-4 text-white md:text-center container mx-auto ">
            <p className="text-2xl font-medium mb-6 lg:mt-12">
              explore the updates coming from across our network
            </p>
            <p className="mb-5 lg:w-1/2 lg:mx-auto">
              Forager International is growing quickly and there are new things
              in development across the our network all the time. This is the
              place to see the latest updates to our companies. Whenever
              something new comes along that is an important update that
              showcases how our network of companies is growing and
              strengthening the relationships we have with our heritage
              partners, we will be publishing it here.
            </p>
            <p className="mb-11">
              Join us on this journey of technology, heritage, and exploration.
            </p>
          </div>
        </section>
        <div className="bg-dark-denim">
          <figure className="relative container mx-auto  hidden lg:flex justify-end pt-8 -mb-10">
            <img
              src={require("../../assets/img/home/rokect.png")}
              alt=""
              className="hidden lg:block absolute -top-16 right-24 w-1/3 rotate-[1deg] mt-12 2xl:mt-8"
            />
          </figure>
          <img src={wave} alt="" className="w-full lg:mt-4" />
        </div>
        <div className="bg-grey px-4 lg:-mt-20">
          <div className="container mx-auto">
          {show ? (
            <div className="max-w-lg lg:max-w-none mx-auto grid grid-cols-4 gap-5 pb-16">
              {cards.map((card) => (
                <div key={card.title} className={card.className}>
                  <AppModal activator={<CardModal card={card} />}>
                    {card.modalContent}
                  </AppModal>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-2xl lg:text-4xl pt-10 pb-48 text-center font-medium text-dark-denim">
              Important news coming soon!
            </p>
          )}
          </div>
        </div>
      </section>
    </MainLayout>
  );
}
